import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import type { Locale } from '@llura/constants';

import { api } from '../lib/api-client';
import { syncFireAndForget } from '../lib/sync';

interface I18nState {
  /** `null` means "not yet chosen" — falls back to browser language at first render. */
  locale: Locale | null;
  setLocale: (locale: Locale) => void;
  hydrate: (locale: Locale | null) => void;
}

export const useI18nStore = create<I18nState>()(
  persist(
    (set) => ({
      locale: null,
      setLocale: (locale) => {
        set({ locale });
        syncFireAndForget(() => api.me.updateUser({ locale }));
      },
      hydrate: (locale) => set({ locale }),
    }),
    {
      name: 'llura.i18n',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
